export default function (data, status = 200) {
  return {
    adapter: async () => {
      return {
        data,
        status
      }
    }
  }
}
